import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-sn",
  "use": "icon-icon-sn-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\" id=\"icon-icon-sn\">\n  <g fill-rule=\"evenodd\" stroke-width=\"1pt\">\n    <path fill=\"#0b7226\" d=\"M0 0h170.7v512H0z\" />\n    <path fill=\"#ff0\" d=\"M170.7 0h170.6v512H170.7z\" />\n    <path fill=\"#bc0000\" d=\"M341.3 0H512v512H341.3z\" />\n  </g>\n  <path fill=\"#0b7226\" d=\"m197 351.7 22-71.7-60.4-46.5h74.5l24.2-76 22.1 76H356L295.6 280l22.1 74-60.3-46.5z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol